import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement,
);

if (process.env.REACT_APP_SENTRY_ENVIRONMENT === 'Production' || process.env.REACT_APP_SENTRY_ENVIRONMENT === 'Development' ) {
	Sentry.init({
		environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
		dsn: 'https://cbfe09d40e618b9fbd35ca37d1220d16@o287010.ingest.us.sentry.io/4508412188884992',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		// tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}

root.render(
	<Router>
		<React.StrictMode>
			<App />
		</React.StrictMode>
	</Router>,
);
